var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCryptoFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#0057FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45993 2H4.0499C3.1199 2 2.64991 3.13 3.30991 3.79L9.03989 9.52C10.6799 11.16 13.3299 11.16 14.9699 9.52L20.6999 3.79C21.3599 3.13 20.8899 2 19.9599 2H18.5499C17.7199 2 16.9199 2.33 16.3299 2.92L12.7499 6.5C12.3399 6.91 11.6799 6.91 11.2699 6.5L7.68991 2.92C7.08991 2.33 6.28993 2 5.45993 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45993 21.97H4.0499C3.1199 21.97 2.64991 20.84 3.30991 20.18L9.03989 14.45C10.6799 12.81 13.3299 12.81 14.9699 14.45L20.6999 20.18C21.3599 20.84 20.8899 21.97 19.9599 21.97H18.5499C17.7199 21.97 16.9199 21.64 16.3299 21.05L12.7499 17.47C12.3399 17.06 11.6799 17.06 11.2699 17.47L7.68991 21.05C7.08991 21.64 6.28993 21.97 5.45993 21.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoFilled);
export default __webpack_public_path__ + "static/media/CryptoFilled.a6b8471fa6a85080429225785b765515.svg";
export { ForwardRef as ReactComponent };